module.exports = __webpack_public_path__ + "static/media/bell.ab7facb5.svg";